export default "__VITE_ASSET__DumwsfrP__"